import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ height: "100vh", position: "relative" }}>
      {/* <Header /> */}
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          bgcolor: "#F5F5F5",
        }}
      >
        {/* 404 Text */}
        <Typography
          variant="h1"
          sx={{ fontSize: "8rem", fontWeight: "bold", color: "#1976D2" }}
        >
          404
        </Typography>

        {/* Page Not Found Message */}
        <Typography variant="h5" sx={{ mb: 2, color: "#333" }}>
          Oops! The page you're looking for doesn't exist.
        </Typography>

        {/* Back to Home Button */}
        <Button
          variant="contained"
          sx={{ mt: 2, bgcolor: "#1976D2", "&:hover": { bgcolor: "#1565C0" } }}
          onClick={() => navigate(-1)}
        >
          Go Back Home
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
